import { ReactNode, useEffect } from 'react';
import { I18nextProvider } from 'react-i18next';
import { useSelector } from 'react-redux';

import { selectAppLocale } from 'features/locale/localeSelectors';

import i18n from '../i18n';
import { getAppLocale, saveAppLocale } from '../utils/localStorage';

interface I18nProviderProps {
  children: ReactNode;
}

export const I18nProvider = ({ children }: I18nProviderProps) => {
  const locale = useSelector(selectAppLocale);

  useEffect(() => {
    const savedLocale = getAppLocale();
    if (!savedLocale) {
      saveAppLocale(locale);
    }

    if (locale && locale !== i18n.language) {
      void i18n.changeLanguage(locale);
    }
  }, [locale]);

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};
